import { ChargePointHasTariff } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/charge-point/charge-point-has-tariff.enum';
import { useTranslation } from 'react-i18next';

import { BooleanTriStateFilterController } from '@shared/filter/boolean-tri-state-filter/boolean-tri-state-filter.controller';

interface ChargePointHasTariffFilterControllerProps {
  // null (not undefined) represents "All" — react-hook-form's Controller
  // falls back to its mount-time default whenever the live value is
  // undefined, so an explicit clear must never be undefined.
  onChange: (value: boolean | null) => void;
  selectedItem?: boolean | null;
}

const backgroundColorByState: Record<ChargePointHasTariff, string> = {
  [ChargePointHasTariff.TRUE]: 'bg-surface-success',
  [ChargePointHasTariff.FALSE]: 'bg-surface-error',
  [ChargePointHasTariff.ALL]: 'bg-surface-brand-secondary',
};

export const ChargePointHasTariffFilterController = ({
  onChange,
  selectedItem,
}: ChargePointHasTariffFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const options = Object.values(ChargePointHasTariff).map((state) => ({
    key: state,
    label: t(`delmonicos-shared-sdk.outputs-charge-point-has-tariff.${state}`),
    value:
      state === ChargePointHasTariff.TRUE
        ? true
        : state === ChargePointHasTariff.FALSE
          ? false
          : null,
    colorClassName: backgroundColorByState[state],
  }));

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <BooleanTriStateFilterController
      iconName="currency-euro-circle"
      text={t('delmonicos-shared-sdk.outputs-charge-point.has-tariff')}
      options={options}
      selectedItem={selectedItem}
      onChange={onChange}
    />
  );
};
